import React, { useState , useEffect } from "react";
import {
  Container,
  Grid,
  Breadcrumbs,
  Link,
  Typography,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  CircularProgress,
  Backdrop,
} from "@material-ui/core";
import moment from "moment";
import axios from "axios";

//context
import { useLayoutState } from "../../context/LayoutContext";
import { useVendorState } from "../../context/VendorContext";
import { tokenConfig } from "../../context/UserContext";

// components
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
//import BarChartByHour from "./components/BarChartByHour/BarChart";
import Table from "./components/Table/Table";

//styles
import useStyles from "./styles";

//helpers
import { encodeForProxy } from "../../healpers/utilityFunctions";
import { BASE_URL } from "../../healpers/api";
import api from "../../healpers/apiRoutes";
import pages from "../../healpers/pageCodes";
import { cloneAndSortDescending } from "../../healpers/dateRange.helpers";

export default function ProductsNotServing() {

  const classes = useStyles();

  //global
  var layoutState = useLayoutState();
  var vendorState = useVendorState();
  
  //local
  const [fullPageLoader, setfullPageLoader] = useState(false);
  const [dateRange, setdateRange] = useState(null);
  const [selectedDateRange, setselectedDateRange] = useState(0);
  const [pageData, setpageData] = useState(null);
  const [campaignRange, setcampaignRange] = useState(null);
  const [selectedCampaignRange, setselectedCampaignRange] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [leftBarChartData, setleftBarChartData] = useState(null);

  useEffect(() => {
    if (layoutState.dates) {
      const weekDateRange = cloneAndSortDescending(layoutState.dates["Campaigns Out Of Budget"].weekly);
      setdateRange(weekDateRange);
      if (weekDateRange.length !== 0)
        setselectedDateRange(0);
    }
    return () => {
      setdateRange(null);
    };
  }, [layoutState.dates]);

  useEffect(() => {
    async function loadData() {
      try {
        setfullPageLoader(true);
        var encodedString = encodeForProxy(
          pages.campaignsoutofbudget,
          vendorState.selected,
          moment(dateRange[selectedDateRange].startdate).format("MM-DD-YYYY"),
          moment(dateRange[selectedDateRange].enddate).format("MM-DD-YYYY")
        );

        axios
          .get(BASE_URL + api.getCache + encodedString, tokenConfig() )
          .then((result) => {
            if (result.data.data) {
              setpageData(result.data.data);
              setcampaignRange(Object.keys(result.data.data));
              setselectedCampaignRange(Object.keys(result.data.data)[0]);
              setTableData(result.data.data[Object.keys(result.data.data)[0]].mainTableData);
           //   setleftBarChartData(result.data.data[Object.keys(result.data.data)[0]].leftBarChartData)
              setfullPageLoader(false);
            }
          })
          .catch((err) => {
            console.log(err);
            setfullPageLoader(false);
          });
      } catch (error) {
        console.log(error);
      }
    }

    if (dateRange && dateRange.length != 0) {
      loadData();
    }

    return () => {
      setTableData([]);
    };
  }, [dateRange, selectedDateRange]);

  return (
    <>
      <Container maxWidth={false}>
        <PageTitle
          title="Campaigns out of Budget"
          breadCrump={
            <Breadcrumbs aria-label="breadcrumb">
              <Link
                color="inherit"
                // href="/#/app/dashboard"
                className={classes.link}
              >
                Advertising
              </Link>
              <Typography className={classes.link}>
                Campaigns out of Budget
              </Typography>
            </Breadcrumbs>
          }
          rightAlignComponent={
            <>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-outlined-label">
                  Select Range
                </InputLabel>
                <Select
                  value={selectedDateRange}
                  onChange={(e) => {
                    setselectedDateRange(e.target.value);
                  }}
                  label="Select Range"
                  disabled={dateRange && dateRange.length === 0 ? true : false}
                >
                  {dateRange ? (
                    dateRange.map((range, index) => {
                      return (
                        <MenuItem value={index}>
                          {range.startdate + " - " + range.enddate}
                        </MenuItem>
                      );
                    })
                  ) : (
                    <MenuItem value={0}>
                      <i>No Dates</i>
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
              <FormControl variant="outlined" className={classes.campaignControl}>
                <InputLabel id="demo-simple-select-outlined-label">
                  Select Campaign
                </InputLabel>
                <Select
                  value={selectedCampaignRange}
                  onChange={(e) => {
                    setselectedCampaignRange(e.target.value);
                    setTableData(pageData[e.target.value].mainTableData);
                    setleftBarChartData(pageData[e.target.value].leftBarChartData);
                  }}
                  label="Select Campaign"
                  disabled={campaignRange && campaignRange.length === 0 ? true : false}
                >
                  {campaignRange ? (
                    campaignRange.map((name) => {
                      return (
                        <MenuItem value={name}>
                          {name}
                        </MenuItem>
                      );
                    })
                  ) : (
                    <MenuItem value={0}>
                      <i>No Campaigns</i>
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            </>
          }
        />
        <Grid container spacing={4}>
          <Grid item xs={12} md={12}>
            <Widget
              upperTitle
              noBodyPadding
              bodyClass={classes.tableOverflow}
              disableWidgetMenu
            >
              <Table tableData={tableData}/>
            </Widget>
          </Grid>
        </Grid>
      </Container>
      <Backdrop
          className={classes.backdrop}
          open={fullPageLoader}
          onClick={() => setfullPageLoader(false)}
        >
          <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
